export default import.meta.ROLLDOWN_FILE_URL_Q1VGrBIuo9NXgOqY_Ww2pA